import { emit, events } from 'elc-service-bus';
import { ProductFilterService } from '../domain/services/ProductFilterService';
import { Filter } from '../domain/entities/Filter';

export interface IAnalyticsAppliedFilters {
    option: string;
    category: string;
}

export class MPPFilteredUseCase {
    private appliedFilters: IAnalyticsAppliedFilters[];

    constructor(appliedFilters: Filter[]) {
        this.appliedFilters = ProductFilterService.getAnalyticsAppliedFilters(appliedFilters);
    }

    execute() {
        emit(events.GRID_FILTERED, {
            appliedFilters: this.appliedFilters
        });
    }
}
